let map;

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById("map")) {
    (g => {
      var h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
      b = b[c] || (b[c] = {});
      var d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams(), u = () => h || (h = new Promise(async (f, n) => {
        await (a = m.createElement("script"));
        e.set("libraries", [...r] + "");
        for (k in g) e.set(k.replace(/[A-Z]/g, t => "_" + t[0].toLowerCase()), g[k]);
        e.set("callback", c + ".maps." + q);
        a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
        d[q] = f;
        a.onerror = () => h = n(Error(p + " could not load."));
        a.nonce = (m.querySelector("script[nonce]") && m.querySelector("script[nonce]").nonce) || "";
        m.head.append(a);
      }));
      d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n));
    })({
      key: apiKey,
      v: "weekly",
    });
    initMap();
  }
});

async function initMap() {
  const { Map, InfoWindow } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

  const mapDiv = document.getElementById("map");
  const mapDataDiv = document.getElementById("map-data");

  // Provide default values
  const defaultZoom = 12;
  const defaultCenter = { lat: 48.8566, lng: 2.3522 }; // Default to Paris coordinates
  let defaultMarkers = [];

  // Parse the JSON string
  let mapData = {
    zoom: defaultZoom,
    center: defaultCenter,
    markers: defaultMarkers,
  };
  
  if (mapDataDiv) {
    try {
      mapData = JSON.parse(mapDataDiv.textContent.trim());
    } catch (error) {
      console.error('Failed to parse map JSON:', error);
    }
  }

  // Extract the data with fallbacks
  const zoom = parseInt(mapData.zoom, 10) || defaultZoom;
  const center = mapData.center || defaultCenter;
  const markers = mapData.markers || [];

  map = new Map(mapDiv, {
    center: center,
    zoom: zoom,
    mapId: '4f40fce91434fc59'
  });
  
  map.maxDefaultZoom = zoom;

  const infowindow = new InfoWindow({
    content: "",
    ariaLabel: "Uluru",
  });

  google.maps.event.addListenerOnce(map, "bounds_changed", function () {
    this.setZoom(Math.min(this.getZoom(), this.maxDefaultZoom));
  });

  const bounds = new google.maps.LatLngBounds();

  // Loop through the markers
  markers.forEach((marker) => {
    const mapDot = document.createElement('div');
    mapDot.style.width = '136px';
    mapDot.style.height = '136px';
    mapDot.style.backgroundColor = 'rgba(35, 129, 196, 0.1)'; 
    mapDot.style.borderRadius = '50%';
    mapDot.style.position = 'relative';
    mapDot.style.display = 'flex';
    mapDot.style.justifyContent = 'center';
    mapDot.style.alignItems = 'center';
    mapDot.style.marginBottom = '-68px';

    const innerDot = document.createElement('div');
    innerDot.style.width = '8px';
    innerDot.style.height = '8px';
    innerDot.style.backgroundColor = '#2381C4';
    innerDot.style.borderRadius = '50%';

    mapDot.appendChild(innerDot);

    const markerViewBackground = new AdvancedMarkerElement({
      map,
      position: { lat: marker.coordinates.lat, lng: marker.coordinates.lng },
      content: mapDot,
      title: marker.title,
      gmpClickable: true
    });

    bounds.extend(new google.maps.LatLng(marker.coordinates.lat, marker.coordinates.lng));

    // Fonction pour échapper le HTML et éviter les injections XSS
    function escapeHtml(text) {
        if (typeof text !== 'string') {
            return '';
        }
        const map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;'
        };
        return text.replace(/[&<>"']/g, function(m) { return map[m]; });
    }
    
    const markerWindowContent = `
      <div class="krg-marker-window">
        <div class="krg-marker-window-item"><strong>${escapeHtml(marker.label || "Audit Conseil")}</strong></div>
        <div class="krg-marker-window-item">${escapeHtml(marker.title)}</div>
      </div>
    `;

    markerViewBackground.addListener("click", () => {
      infowindow.close();
      infowindow.setPosition(marker.coordinates);
      infowindow.setContent(markerWindowContent);
      infowindow.open(map);
    });
  });

  if (markers.length) {
    map.fitBounds(bounds);
  }
}
